import { render, staticRenderFns } from "./BroadcastStatusPill.vue?vue&type=template&id=0684fa71&scoped=true"
import script from "./BroadcastStatusPill.vue?vue&type=script&lang=js"
export * from "./BroadcastStatusPill.vue?vue&type=script&lang=js"
import style0 from "./BroadcastStatusPill.vue?vue&type=style&index=0&id=0684fa71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0684fa71",
  null
  
)

export default component.exports